// import createGenerateClassName from '@mui/styles/createGenerateClassName';
// import jssPreset from '@mui/styles/jssPreset';
// import { create } from 'jss';
// import jssExtend from 'jss-plugin-extend';
// import rtl from 'jss-rtl';
import Provider from 'react-redux/es/components/Provider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import AppContext from './AppContext';
import routes from './fuse-configs/routesConfig';
import store from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { SocketProvider } from './SocketProvider';
import { changeLanguage, fetchTranslations, selectIsTranslationsInitialized } from './store/i18nSlice';
import { useDispatch, useSelector } from 'react-redux';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { useEffect, useState } from 'react';
import new_store from 'app/store';
import i18n from 'i18n';
let persistor = persistStore(store);
const TranslationLoader = ({ children }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const isInitialized = useSelector(selectIsTranslationsInitialized);
  // Nuevo: obtener idioma de Redux o localStorage primero
  useEffect(() => {
    let userLanguage = null;
    // 1. Intentar obtener de Redux
    try {
      userLanguage = new_store.getState().i18n?.language;
    } catch (e) {}
    // 2. Si no, intentar obtener de localStorage
    if (!userLanguage) {
      try {
        const lSDataRaw = localStorage.getItem('persist:root');
        if (lSDataRaw) {
          const lSData = JSON.parse(lSDataRaw);
          if (lSData && lSData.loadz_auth) {
            const authReducer = JSON.parse(lSData.loadz_auth).AuthReducer;
            if (authReducer && authReducer.user && authReducer.user.language_code) {
              userLanguage = authReducer.user.language_code;
            }
          }
        }
      } catch (e) {}
    }
    // 3. Si no, usar el del backend (como antes)
    if (!userLanguage) {
      userLanguage = new_store.getState().loadz_auth?.AuthReducer?.user?.language_code || 'en';
    }
    // Forzar el cambio de idioma solo si no está inicializado o si el idioma cambió
    dispatch(fetchTranslations(userLanguage))
      .unwrap()
      .then(() => {
        dispatch(changeLanguage(userLanguage));
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error al inicializar traducciones:', err);
        setIsLoading(false);
      });
  }, [dispatch]);

  if (isLoading) {
    return <FuseSplashScreen />;
  }

  return children;
};


const withAppProviders = (Component) => (props) => {
  const WrapperComponent = () => (
    <AppContext.Provider
      value={{
        routes,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
        <TranslationLoader>
          <SocketProvider>
            <StyledEngineProvider injectFirst>
              <Component {...props} />
            </StyledEngineProvider>
          </SocketProvider>
          </TranslationLoader>
          </PersistGate>
        </Provider>
      </LocalizationProvider>
    </AppContext.Provider>
  );

  return WrapperComponent;
};

export default withAppProviders;
